<template>
  <div class="sunshine-port">
    <Crumbs :info='info' :title='navList[0]' :nextTitle="navList[flag]"/>
    <div class="customs-container">
      <!-- <div class="port-nav">
        <menu-com :navList='navList'>
        </menu-com>
      </div> -->
      <div class="port-content">
        <!-- 书写内容区域 -->
        <h2>{{newslist.noticeTitle}}</h2>
        <mavon-editor :value="newslist.noticeContent" defaultOpen="preview" :boxShadow="false"
          style="z-index:1;margin-top: 20px"  :subfield="false" :toolbarsFlag="false">
        </mavon-editor>

      </div>
    </div>
  </div>
</template>

<script>
import menuCom from "../common/menuCom.vue"
import Crumbs from "./Crumbs.vue"
import {navList} from "../../../../model/policies"
import Customs from "../Customs";
import axios from "axios";
export default {
  components:{
    menuCom,Crumbs,Customs
  },

  data () {
    return {
      info:{},
      navList,
      flag:1,
      newslist: {}
    }
  },
  methods:{
    getpage(){
      axios({
        method: 'GET',
        url: `http://121.40.212.122:8091/system/notice/${this.$route.params.id}`,
        data: {
          id: this.$route.params.id
        }
      }).then(response => {
        console.log(response);
        this.newslist = response.data.data;
      })
    }
  },
  created(){
    this.getpage();
    this.info={
      ids:this.$route.query.id,
      label:this.$route.query.title,
      path:this.$route.fullPath
    }
    this.flag = this.$route.query.flag
    console.log(this.flag);

    // console.log(this.navList);
    // console.log(this.info);
    // console.log(this.info.path.inclouds(this.navList[index]));

    // for (let index = 0; index < this.navList.length; index++) {
    //   if(this.info.path.inclouds(this.navList[index]))

    // }
    const path=this.$route.fullPath;
    const index=navList.findIndex(item=>item.path===path);
    if(index!==-1){
      this.info=navList[index];
    }

  }
};
</script>

<style scoped>
.customs-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  display: flex;
  padding: 34px 30px;
  border: 1px solid #d3d3d3;
  margin-top: 30px;
  margin-bottom: 186px;
}
.port-content {
  flex:1;
}
.port-nav {
  margin-right: 44px;
  height: auto;
}
.port-content h2 {
  height: 38px;
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: center;
  color: #34373b;
  line-height: 38px;
  display: block;
  margin-bottom: 34px;
}
.port-content p {
  text-indent: 2em;
  font-size: 18px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #000000;
  line-height: 34px;
  margin-bottom: 34px;
}

.customs-list {
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  color:  #585d66;
  line-height: 38px;
}

.customs-container li {
  margin-bottom: 24px;
  cursor: pointer;
}
.customs-container li:hover{
  color: #3682ed;
}
.port-content>div{
  font-size: 22px;
  font-family: PingFangSC, PingFangSC-Regular;
  font-weight: 400;
  text-align: left;
  color: #33363b;
  line-height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.port-content>div i {
  border: 1px solid #d3d3d3;
  margin-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/children/Policies/Detail/Customs.vue